import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { HeaderProgressTracker } from '../../Common/HeaderStepper/HeaderProgressTracker';
import * as Steps from './steps/index';
import { saveSessionEvent } from "../../../session";
import {
  SESSION_STORAGE_TERM_LIFE_INSURANCE_OBJECT_KEY,
  SESSION_SAVE_QUOTE_KEY,
  setSessionStorageItem,
  getSessionStorageItem,
  ADVISOR_OBJECT_KEY,
  SESSION_STORAGE_CASE_RETURN_PATH
} from '../../../sessionStorage';
import Breadcrumb from '../../Common/Breadcrumb/Breadcrumb';
import './TermLifeInsurance.scss'
import { CLIENT_TYPES, OneClickProductType, RadioSelected } from '../../Common/Constant';

export default function TermLifeInsurance(props) {

  useEffect(() => { saveSessionEvent() }, [props.location])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  const path = props.location ? props.location.pathname.split("/").pop() : null;
  const allFormState = getSessionStorageItem(SESSION_STORAGE_TERM_LIFE_INSURANCE_OBJECT_KEY);
  const savedQuote = getSessionStorageItem(SESSION_SAVE_QUOTE_KEY);
  const advisorObject = getSessionStorageItem(ADVISOR_OBJECT_KEY);
  const productObject = getSessionStorageItem(SESSION_STORAGE_CASE_RETURN_PATH);
  const isCopyCaseData = allFormState && allFormState.isCopyCaseData ? allFormState.isCopyCaseData : false;

  const prefill = props.location.search && props.location.search.toLowerCase().includes('prefill');
  const advisorInfo = {
    firstName: advisorObject && advisorObject.fullName.split(' ')[0],
    lastName: advisorObject && advisorObject.fullName.split(' ')[1]
  }

  let newFormState = {
    currentStep: 1,
    pages: {
      retrieveAccount: Steps.RetrieveAccount.DefaultFormState(prefill),
      insuredBasicInfo: Steps.InsuredBasicInfo.DefaultFormState(prefill),
      quoter: Steps.Quoter.DefaultFormState(prefill),
      attestation: Steps.Attestation.DefaultFormState(),
      //health: Steps.Health.DefaultFormState(prefill),
      //healthProfile: Steps.HealthProfile.DefaultFormState(),
      //policyRider: Steps.PolicyRider.DefaultFormState(prefill),
      applicationInformation: Steps.ApplicationInformation.DefaultFormState(),
      esign: Steps.ESign.DefaultFormState(prefill, advisorInfo),
      yourInformation: Steps.YourInformation.DefaultFormState()
    },
  }
  const initialFormState = allFormState || newFormState;

  useEffect(() => {
    if (!allFormState && savedQuote) {
      const healthClass = savedQuote.quoter.healthClass ? getKnockoutArray() : initialFormState.pages.health;
      initialFormState.currentStep = 8;
      initialFormState.pages.insuredBasicInfo = savedQuote.insuredBasicInfo || initialFormState.pages.insuredBasicInfo;
      initialFormState.pages.retrieveAccount = savedQuote.clientType || initialFormState.pages.retrieveAccount;
      initialFormState.pages.quoter = savedQuote.quoter || initialFormState.pages.quoter;
      initialFormState.pages.health = healthClass;
      setFormState(initialFormState);
      setSessionStorageItem(SESSION_STORAGE_TERM_LIFE_INSURANCE_OBJECT_KEY, initialFormState);
      sessionStorage.removeItem(SESSION_SAVE_QUOTE_KEY);
    }
  }, []);
  const getKnockoutArray = () => {
    if (!savedQuote.quoter || !savedQuote.quoter.healthClass) {
      return null;
    }
    else {
      switch (savedQuote.quoter.healthClass) {
        case 'PP':
          return { knockouts: [true, false, false, false, false] };
        case 'P':
          return { knockouts: [false, true, false, false, false] };
        case 'RP':
          return { knockouts: [false, false, true, false, false] };
        case 'R':
          return { knockouts: [false, false, false, true, false] };
        case 'RR':
          return { knockouts: [false, false, false, false, true] };
        default:
          return { knockouts: [false, false, false, false, false] };
      }
    }
  }
  const [formState, setFormState] = useState(initialFormState);
  const carriersForAttestationPage = ['Legal & General', 'AIG', 'Pacific Life', 'Prudential', 'John Hancock', 'Protective'];

  useEffect(() => {

    if (!path) {
      return;
    }

    let nextStep = steps.find((s) => s.path === path);

    if (!nextStep) {
      const newPath = props.location ? props.location.pathname.split("/").slice(-2) : null;
      if (!newPath) {
        return;
      }

      nextStep = steps.find((s) => s.path === newPath[0]);
      if (!nextStep) {
        return;
      }
    }
    const newFormState = { ...formState, currentStep: nextStep.step };
    setFormState(newFormState);
  }, [path]);

  const skipHealthOnBack = () => {
    return (
      ((formState.pages.retrieveAccount.clientType === 'Prospect' && formState.pages.insuredBasicInfo.bmi)
        || (formState.pages.retrieveAccount.clientType === 'Existing' && formState.pages.retrieveAccount.policyOwner === 'no' && formState.pages.insuredBasicInfo.bmi)
      )
    )
  }

  const skipHealthOnOwnerNext = () => {
    return ((formState.pages.retrieveAccount.clientType === "Existing" && formState.pages.retrieveAccount.policyOwner === 'yes') && (formState.pages.retrieveAccount.bmi))
  }

  const skipEsignOrAttestationPageOnNext = (isEsignPage) => {
    const state = formState.pages.insuredBasicInfo.state;
    const carrierName = formState.pages.quoter.carrierName;
    const isPrudentialLifeInsuranceCompanyOfNY = (formState.pages.quoter.productID === 1028 && formState.pages.quoter.carrierID === 1009)
    const isProtectiveLifeAndAnnuityNY = (formState.pages.quoter.productID === 1030 && formState.pages.quoter.carrierID === 1006)
    const isSymetraTerm = formState.pages.quoter.productID === 1039;
    if (isEsignPage) {
      return (state !== 'NY' && (carriersForAttestationPage.includes(carrierName) || isSymetraTerm) || (state === 'NY' && ((isProtectiveLifeAndAnnuityNY) || (isPrudentialLifeInsuranceCompanyOfNY && formState.pages.applicationInformation.replacement !== "yes"))));
    }
    else {
      return (state === 'NY' && !(isProtectiveLifeAndAnnuityNY || (isPrudentialLifeInsuranceCompanyOfNY && formState.pages.applicationInformation.replacement !== "yes"))) || (state !== 'NY' && (!carriersForAttestationPage.includes(carrierName) && !isSymetraTerm));
    }
  }

  const onNext = (stepToSet = 0) => {

    let nextStep;
    if (stepToSet > 0) {
      nextStep = steps.find((s) => s.step === stepToSet)
    } else {
      nextStep = steps.find(s => s.step === formState.currentStep + 1);

      if (nextStep.path === 'ESign' && (skipEsignOrAttestationPageOnNext(true))) {
        nextStep = steps.find(s => s.step === nextStep.step + 1);
      }
      if (nextStep.path === 'Attestation' && (skipEsignOrAttestationPageOnNext(false))) {
        nextStep = steps.find(s => s.step === nextStep.step + 1);
      }
      if (nextStep.path === 'QuoteSuccess' && (formState.pages.yourInformation.isQuoteFailure === true)) {
        nextStep = steps.find(s => s.step === nextStep.step + 1);
      }
    }

    if (!nextStep) {
      throw new Error('onNext did not find a next step');
    }

    const newFormState = { ...formState, currentStep: nextStep.step };
    setFormState(newFormState);
    setSessionStorageItem(SESSION_STORAGE_TERM_LIFE_INSURANCE_OBJECT_KEY, newFormState);
    props.history.push(`/Products/Term/${nextStep.path}`);
    window.scroll(0, 0);
  };

  const onBack = () => {
    let backStep = steps.find(s => s.step === formState.currentStep - 1);
    if (backStep) {
      if (backStep.path === 'QuoteSuccess' && (formState.pages.yourInformation.isQuoteFailure === true)) {
        backStep = steps.find(s => s.step === backStep.step - 1);
      }
      if (backStep.path === 'Attestation' && skipEsignOrAttestationPageOnNext(false)) {
        backStep = steps.find(s => s.step === backStep.step - 1);
      }
      if (backStep.path === 'ESign' && skipEsignOrAttestationPageOnNext(true)) {
        backStep = steps.find(s => s.step === backStep.step - 1);
      }
      const newFormState = { ...formState, currentStep: backStep.step };

      setFormState(newFormState);
      setSessionStorageItem(SESSION_STORAGE_TERM_LIFE_INSURANCE_OBJECT_KEY, newFormState);

      props.history.push(`/Products/Term/${backStep.path}`);
      window.scroll(0, 0);

    }
    else {
      props.history.push(productObject ? productObject : '/Products/Landing/Term');
      sessionStorage.removeItem(SESSION_STORAGE_CASE_RETURN_PATH);
    }
  };

  const onFieldChange = (step, field, value) => {
    setFormState({ ...formState, pages: { ...formState.pages, [step]: { ...formState.pages[step], [field]: value } } });
  }

  const calculatePercentage = (totalStep, step, categoryStep, currentCateTotalStep) => {
    let stepPer = ((step - 1) / totalStep * 100);
    let cateCount = currentCateTotalStep === 1 ? 1 : (((categoryStep - 0.5) / currentCateTotalStep) * (100 / totalStep));
    return stepPer + cateCount;
  }

  const setAllFormOnAccountNoChanged = (value = null, isSetPrefillData = false) => {
    let newFormState = formState;
    const clientData = isSetPrefillData ? newFormState.pages.retrieveAccount : Steps.RetrieveAccount.DefaultFormState(prefill);
    const insuredData = isSetPrefillData ? newFormState.pages.insuredBasicInfo : Steps.InsuredBasicInfo.DefaultFormState(prefill);
    clientData.clientType = value || formState.pages.retrieveAccount.clientType;
    if(!value){
      clientData.officeFa = formState.pages.retrieveAccount.officeFa;
      if(formState.pages.retrieveAccount.clientType === 'Existing'){
        clientData.officeAccount = formState.pages.retrieveAccount.officeAccount;
        clientData.branchOptions = formState.pages.retrieveAccount.branchOptions;
        clientData.faNum = formState.pages.retrieveAccount.faNum;
        clientData.officeNum = formState.pages.retrieveAccount.officeNum;
      }
    }
    newFormState.pages.retrieveAccount = clientData;
    newFormState.pages.insuredBasicInfo = insuredData;
    setFormState({ ...newFormState });
  }
  const setFormStateToDefault = () => {
    let newFormState = formState;
    newFormState.pages.retrieveAccount = Steps.RetrieveAccount.DefaultFormState(prefill);
    newFormState.pages.retrieveAccount.clientType = 'Prospect';
    setFormState({ ...newFormState });
  }

  const clearFormState = () => {
    sessionStorage.removeItem(SESSION_STORAGE_TERM_LIFE_INSURANCE_OBJECT_KEY);
    setFormState(newFormState);
    props.history.push('/Products/Term/Client');
  }

  const steps = [
    {
      step: 1,
      path: 'Client',
      progressTitle: 'Basics',
      component: (
        <Steps.RetrieveAccount
          formState={formState.pages.retrieveAccount}
          onFieldChange={(field, value) => onFieldChange('retrieveAccount', field, value)}
          onNext={onNext}
          onBack={onBack}
          fullFormState={formState}
          isTermRetrieveQuote ={true}
          setAllFormOnAccountNoChanged={(value, isSetPrefillData)=> setAllFormOnAccountNoChanged(value, isSetPrefillData)}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
          esignData = {Steps.ESign.DefaultFormState(prefill)}
          isTerm={true}
          insuredInfoDefaultState = {Steps.InsuredBasicInfo.DefaultFormState(prefill)}
          isCopyCaseData = {isCopyCaseData}
        />
      ),
      breadCrumbTitle: 'NEW CASE',
      categoryNumber: 1,
      categoryStep: 1
    },
    {
      step: 2,
      path: 'BasicInfo',
      progressTitle: 'Basics',
      component: (
        <Steps.InsuredBasicInfo
          formState={formState.pages.insuredBasicInfo}
          onFieldChange={(field, value) => onFieldChange('insuredBasicInfo', field, value)}
          onNext={onNext}
          onBack={onBack}
          fullFormState={formState}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
          ageSpecs={{ min: 0, max: 124 }}
        />
      ),
      breadCrumbTitle: 'NEW CASE',
      categoryNumber: 1,
      categoryStep: 2,
    },
    {
      step: 3,
      path: 'Quote',
      progressTitle: 'Quoter',
      component: <Steps.Quoter
        formState={formState.pages.quoter}
        onFieldChange={(field, value) => onFieldChange('quoter', field, value)}
        onNext={onNext}
        onBack={onBack}
        isProspectMode={formState.pages.retrieveAccount.clientType === "Prospect"}
        fullFormState={formState}
        insuredFormstate={formState.pages.retrieveAccount}
        onMultiFieldChange={(fs) => {
          setFormState(fs);
        }}
        allForms={formState}
      />,
      categoryNumber: 2,
      categoryStep: 2,
      hideContainer: true,
      hideProgressTracker: true,
      hideMainHeader: true
    },
    {
      step: 4,
      path: 'ApplicationInfo',
      progressTitle: 'Basics',
      component: (
        <Steps.ApplicationInformation
          formState={formState.pages.applicationInformation}
          onFieldChange={(field, value) => onFieldChange('applicationInformation', field, value)}
          onNext={onNext}
          onBack={onBack}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
          fullFormState={formState}
          isTerm={true}
        />
      ),
      breadCrumbTitle: 'NEW CASE',
      categoryNumber: 1,
      categoryStep: 4,
    },
    {
      step: 5,
      path: 'ESign',
      progressTitle: 'Basics',
      component: (
        <Steps.ESign
          formState={formState.pages.esign}
          onFieldChange={(field, value) => onFieldChange('esign', field, value)}
          onNext={onNext}
          onBack={onBack}
          fullFormState={formState}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
        />
      ),
      breadCrumbTitle: 'QUOTE',
      categoryNumber: 3,
      categoryStep: 5,
    },
    {
      step: 6,
      path: 'Attestation',
      progressTitle: 'Basics',
      component: (
        <Steps.Attestation
          formState={formState.pages.attestation}
          quoterState={formState.pages.quoter}
          onFieldChange={(field, value) => onFieldChange('attestation', field, value)}
          onNext={onNext}
          onBack={onBack}
        />
      ),
      breadCrumbTitle: 'QUOTE',
      categoryNumber: 3,
      categoryStep: 5,
    },
    {
      step: 7,
      path: 'YourInformation',
      progressTitle: 'Basics',
      component: (
        <Steps.YourInformation
          formState={formState.pages.yourInformation}
          roleType={props.roleType}
          basicInfo={formState}
          isTerm={true}
          productType={'TERM'}
          selectedQuote={formState.pages.quoter}
          onFieldChange={(field, value) => onFieldChange('yourInformation', field, value)}
          onNext={onNext}
          onBack={onBack}
          isSubmitCase={true}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
          oneClickProductType ={OneClickProductType.FullUW}
        />
      ),
      breadCrumbTitle: 'QUOTE',
      categoryNumber: 4,
      categoryStep: 1,
    },
    {
      step: 8,
      path: 'QuoteSuccess',
      progressTitle: 'Basics',
      component: (
        <Steps.QuoteSuccess
          formState={formState.pages.quoteSuccess}
          onFieldChange={(field, value) => onFieldChange('quoteSuccess', field, value)}
          onNext={onNext}
          onBack={onBack}
          yourInformation={formState.pages.yourInformation}
          clearFormState={clearFormState}
        />
      ),
      breadCrumbTitle: 'QUOTE',
      categoryNumber: 4,
      lastStep: true,
    },
    {
      step: 9,
      path: 'QuoteFailure',
      progressTitle: 'Basics',
      component: (
        <Steps.QuoteFailure
          formState={formState.pages.quoteFailure}
          onFieldChange={(field, value) => onFieldChange('quoteFailure', field, value)}
          onNext={onNext}
          onBack={onBack}
          yourInformation={formState.pages.yourInformation}
          clearFormState={clearFormState}
        />
      ),
      breadCrumbTitle: 'QUOTE',
      categoryNumber: 4,
      lastStep: true,
    },
  ];

  const currentStepObj = steps.find(s => s.step === formState.currentStep) || steps[0];
  const categories = steps.filter((o) => o.categoryNumber === currentStepObj.categoryNumber);
  const progressOption = steps.map((o) => o.progressOption);

  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  var uniqueArray = progressOption.filter(onlyUnique);

  const getPath = (progressOption) => {
    if (progressOption === "Your Information") {
      onNext(5);
    } else if (progressOption === "Client Info") {
      onNext(1);
    }
  }

  const totalCategoriesStep = Math.max.apply(Math, categories.map(function (o) { return o.categoryStep; }))
  const percent = calculatePercentage(4, currentStepObj.categoryNumber, currentStepObj.categoryStep, totalCategoriesStep);
  return (
    <div>
      <Helmet>
        <title>Covr Advisor - {currentStepObj.progressTitle} </title>
      </Helmet>

      {currentStepObj.path === "Quote" &&
        <Breadcrumb breadcrumbLinks={[{ name: 'HOME', href: '/' }, { name: 'PRODUCTS', href: '/Products' }, { name: 'TERM LIFE INSURANCE', href: '/Products/Landing/Term' }]} currentPage={'QUOTE'} />
      }

      <HeaderProgressTracker breadCrumb=" QUOTE" breadcrumbLink = {[{ name: 'PRODUCTS', href: '/Products' }, {name: 'TERM LIFE INSURANCE', href: '/Products/Landing/Term'}]} hidePadding={currentStepObj.path !== 'schedule-appointment' ? false : true} hidden={currentStepObj.hideMainHeader} hideStepsDropdown={currentStepObj.hideStepsDropdown} getPath={(value) => getPath(value)} progressTitle={uniqueArray} currentPage={true} showContainer={false} hideProgressTracker={false} title="Term Life Insurance" stepName={currentStepObj.progressTitle} step={currentStepObj.categoryNumber} categoryStep={currentStepObj.categoryStep} path={currentStepObj.path} totalSteps={4} whiteBg={currentStepObj.whiteBackground} percent={percent} lastStep={currentStepObj.lastStep} headerProductsText={true}>
        <div className={`Term-Life-Insurance ${currentStepObj.path !== 'schedule-appointment' ? 'mt-4' : ''}`}>
          {currentStepObj.component}
        </div>
      </HeaderProgressTracker>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/TermLifeInsurance.js